__turbopack_context__.v({
  "completed": "StepperStep-module-sass-module__fCew6W__completed",
  "inactive": "StepperStep-module-sass-module__fCew6W__inactive",
  "progress": "StepperStep-module-sass-module__fCew6W__progress",
  "step-label": "StepperStep-module-sass-module__fCew6W__step-label",
});
